import React from 'react';
import { HotKeysRow } from '../index';
import useTranslation from '../../hooks/useTranslation';
import { TranslationKeys } from '../../core/constants/translationKeys';

function HotKeys({
  children,
  aKey,
  isShowMakeBet = true,
  isShowHalfBet = true,
  isShowDoubleBet = true,
}) {
  const t = useTranslation();

  return (
    <div className='cpt-row-boxes-wrapper'>
      {isShowMakeBet && <HotKeysRow actionName={t(TranslationKeys.MakeBet)} keyboardName='Space' />}
      {isShowHalfBet && (
        <HotKeysRow
          actionName={aKey ? t(TranslationKeys.aKey) : t(TranslationKeys.HalfBet)}
          keyboardName='A'
        />
      )}
      {isShowDoubleBet && <HotKeysRow actionName={t(TranslationKeys.DoubleBet)} keyboardName='S' />}
      {children}
    </div>
  );
}

export default HotKeys;
